import { useEffect } from 'react';
import * as React from 'react';

import { featureFlagsVar } from '@/graphql/reactiveVars';
import * as diagnostics from '@/utils/diagnostics';

import { FeatureFlag, FeatureFlagMap } from './featureFlags.types';
import { useFeatureFlagsQuery } from './graphql/FeatureFlags.generated';

export const FeatureFlagsContext = React.createContext<FeatureFlag[]>([]);

export function FeatureFlagsProvider({ children }: React.PropsWithChildren) {
  const { data } = useFeatureFlagsQuery({
    fetchPolicy: 'cache-first',
    onError: (error) => {
      diagnostics.error('Failed to fetch feature flags', error);
    },
  });

  useEffect(() => {
    if (!data?.featureFlagEvaluations) {
      return;
    }

    const featureFlags: FeatureFlagMap = data.featureFlagEvaluations.reduce(
      (acc, flag) => ({
        ...acc,
        [flag.name]: flag.value,
      }),
      {}
    );

    featureFlagsVar(featureFlags);
  }, [data?.featureFlagEvaluations]);

  return (
    <FeatureFlagsContext.Provider
      // The query types each flag's `name` as a plain string, while
      // FeatureFlag.name is the enumerated FeatureFlagName. The cast is safe
      // because unknown names are guarded in useFeatureFlag.
      value={(data?.featureFlagEvaluations ?? []) as FeatureFlag[]}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
}
